import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      // Locale JSON is unhashed, so browsers that cached it under the old one-year
      // Cache-Control keep serving stale keys (CPI-977: raw "waiveBankGuarantee" on
      // Sales Info). The build version changes the URL so every deploy is a fresh fetch.
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${encodeURIComponent(process.env.VERSION || '')}`,
    },
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js